import React from "react"
import { graphql } from "gatsby"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import parse from "html-react-parser"

const TitleContentImageItem = ({ title, richContent, items, image }) => {
  return (
    <section className="title-content-image-item">
      <div className="title-content-image-item__inner">
        <div className="title-content-image-item__title">
          {title && <h2>{parse(title)}</h2>}
          {richContent && <StructuredText data={richContent} />}
        </div>

        <div className="title-content-image-item__image">
          {image && <Asset asset={image} />}
        </div>

        <div className="title-content-image-item__items">
          {items?.length > 0 &&
            items.map((item, index) => (
              <div className="title-content-image-item__item" key={index}>
                {item.title && <h3>{parse(item.title)}</h3>}
                {item.richContent && <StructuredText data={item.richContent} />}
              </div>
            ))}
        </div>
      </div>
    </section>
  )
}

export default TitleContentImageItem

export const query = graphql`
  fragment TitleContentImageItemProps on DatoCmsTitleContentImageItem {
    ... on DatoCmsTitleContentImageItem {
      id
      title
      richContent {
        value
      }
      image {
        ...InternalAssetProps
      }
      items {
        title
        richContent {
          value
        }
        image {
          ...InternalAssetProps
        }
      }
    }
  }
`
